@if (isPopupOpen) {
  <div class="bm--bg-popup" (click)="closePopup()">
    <div
      class="share-track-popup theme-shareTrackPopup__bg"
      [ngClass]="{ 'share-track-popup--colorSettingsMode': colorSettingsMode }"
      (click)="$event.stopPropagation()"
    >
      <div class="share-track-popup__header-box">
        <p class="share-track-popup__header-title theme-shareTrackPopup__title">
          {{ lg.tracksBlock.share }}
        </p>
        <div class="btv-icon-close theme-shareTrackPopup__closeIcon" (click)="closePopup()"></div>
      </div>
      <div class="share-track-popup__descr-box">
        <bmcore-track-descr
          [fixedBeat]="track"
          (closeCartPopupEvent)="closePopup()"
          [parentComponent]="'share-track-popUp'"
          [appType]="appType"
          [showVerificationIcon]="showVerificationIcon"
          [verificationIconSize]="12"
        >
        </bmcore-track-descr>
      </div>
      <p class="share-track-popup__link-title theme-shareTrackPopup__linkTitle">{{ lg.tracksBlock.shareLink }}</p>
      <div class="share-track-popup__link-box">
        <label class="share-track-popup__input-box">
          <!-- value="{{ url + this.routingPathService.getBeatPageUrl(track.id) }}"-->
          <!-- work on staging and production, but doesn't work locally because of get param ?devBeatmakerId=119618 -->
          <input
            type="text"
            class="bm--text-field theme-shareTrackPopup__linkInput"
            [value]="shareTrackLink"
            #trackLinkInput
            readonly
          />
        </label>
        <div class="share-track-popup__btn-box">
          <bmcore-button
            [themeBtnClass]="
              isCopiedToClipboard
                ? 'theme-btn__shareTrackPopup-btnLinkCopied'
                : 'theme-btn__shareTrackPopup-btnCopyLink'
            "
            [themeIconClass]="
              isCopiedToClipboard
                ? 'theme-icon__shareTrackPopup-btnLinkCopiedIcon'
                : 'theme-icon__shareTrackPopup-btnCopyLinkIcon'
            "
            title="{{ isCopiedToClipboard ? lg.button.linkCopied : lg.button.copyLink }}"
            icon="btv-icon-btn-copy"
            (clickHandler)="copyInputMessage(trackLinkInput)"
            [disabled]="isCopiedToClipboard"
          >
          </bmcore-button>
        </div>
      </div>
    </div>
  </div>
}
